import MappingStats from "./MappingStats";

export default MappingStats;
